
const getters = {
  listAll: state => {
    return state.role_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/clipboard/clipboard.getters.js
// module id = null
// module chunks = 